<template>
  <div class="locale-picker" :class="position">
    <div class="locale selected" @click="toggleMenu()">
      <img :src="'static/flags/' + localeSelected.flag + '.svg'"/>
      <mu-icon class="close" :class="{ 'active' : toggleLocales === true }"
               :value="isMenuTop ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"/>
      <span class="selectedLang" v-text="getLangLabel(locales[selected].cl) + ' (' + locales[selected].cc + ')'"></span>
    </div>
    <div class="menu" :class="{ 'visible' : toggleLocales }">
      <div class="locale clearfix" v-for="locale, i in locales" :key="`locale-${i}`" @click="onSelect(i)">
        <img :src="'static/flags/' + locale.flag + '.svg'"/>
        <span v-text="getLangLabel(locale.cl) + ' (' + locale.cc + ')'"></span>
      </div>
    </div>
  </div>
</template>
<script>
  import Config from '../../config';
  import iso from 'iso-countries-languages';

  export default {
    props: {
      position: {
        type: String,
        default: "top"
      },
      showName: {
        type: Boolean,
        default: true,
      }
    },
    data() {
      return {
        toggleLocales: true,
        selected: 1,

        url: Config.ApplicationContext === 'lowcarbprogram' ? 'https://www.lowcarbprogram.com/' : "https://www.grohealth.com/",
        locales: [{
          flag: "gb",
          cc: "GB",
          cl: "en",
          locale: "en_GB",

        }, {
          flag: "ca",
          cc: "CA",
          cl: "en",
          locale: "en_CA",
        }, {
          flag: "ca",
          cc: "CA",
          cl: "fr",
          locale: "fr_CA",
        },
          /*{
              flag : "us",
              cc : "US",
              cl : "en",
              locale : "en_US",
          }*/]
      }
    },
    methods: {
      toggleMenu() {
        let self = this;
        self.toggleLocales = !self.toggleLocales;
      },
      onSelect(i) {
        let self = this;
        self.selected = i;
        let obj = self.locales[self.selected];
        self.setCookie("locale", obj.locale, 7);
        let url = self.url + obj.locale + '/';
        url = url.replace('_', '-');
        window.location.href = url;
      },
      setCookie(name, value, days) {
        var expires = "";
        if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
          expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
      },
      getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') c = c.substring(1, c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
      },
      explodeLocaleCookie() {
        let self = this;
        let split = self.getCookie("locale") || "en_GB";
        let cookie = split.split("_");
        return cookie;
      },
      getCountryLabel(country) {
        let self = this;
        let lang = self.explodeLocaleCookie()[0];
        return iso.getCountry(lang, country);
      },
      getLangLabel(cl) {
        let self = this;
        let lang = self.explodeLocaleCookie()[0];
        return iso.getLanguage(lang, cl);
      }
    },
    mounted() {
      let self = this;
      let cookieValue = self.getCookie('locale') || 'en_GB';
      let index = _.findIndex(self.locales, {locale: cookieValue});
      self.selected = index;
      self.toggleLocales = false;
      $('.locale-picker .menu').mouseleave(function () {
        self.toggleLocales = false;
      });
      $('body, html').on('click', function (eve) {
        if ($('.locale-picker .menu').hasClass('visible')) {
          self.toggleLocales = false;
        }
      });
    },
    computed: {
      localeSelected() {
        let self = this;
        return self.locales[self.selected];
      },
      isMenuTop() {
        let self = this;
        return self.position === 'top';
      }
    }
  }
</script>
<style>
  .locale-picker {
    display: inline-block;
    min-width: 100px;
    position: relative;
    top: -14px;
  }
  .locale-picker.top .locale.selected {
    box-shadow: none;
  }

  span.selectedLang {
    position: relative;
    top: -4px;
    left: 14px;
  }

  .locale-picker .close {
    position: relative;
    left: 10px;
    cursor: pointer;
    color: #0179d5;
    -webkit-transition: all 0.2s ease-out;
    -moz-transition: all 0.2s ease-out;
    -o-transition: all 0.2s ease-out;
    transition: all 0.2s ease-out;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  .locale-picker .close.active {
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -o-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    transform: rotate(180deg);
    -webkit-transition: all 0.2s ease-out;
    -moz-transition: all 0.2s ease-out;
    -o-transition: all 0.2s ease-out;
    transition: all 0.2s ease-out;
  }

  .locale-picker .menu {
    width: 190px;
    white-space: nowrap;
    top: 90px;
    left: -30px;
    position: absolute;
    z-index: 99999;
    overflow: hidden;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    -moz-opacity: 0;
    -khtml-opacity: 0;
    -webkit-opacity: 0;
    opacity: 0;
    -ms-filter: progid:DXImageTransform.Microsoft.Alpha(opacity=0);
    filter: alpha(opacity=0);
    -webkit-transition: all 0.2s ease-out;
    -moz-transition: all 0.2s ease-out;
    -o-transition: all 0.2s ease-out;
    transition: all 0.2s ease-out;
    -webkit-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
    -moz-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
    visibility: hidden;
  }

  .locale-picker .menu.visible {
    -moz-opacity: 1;
    -khtml-opacity: 1;
    -webkit-opacity: 1;
    opacity: 1;
    -ms-filter: progid:DXImageTransform.Microsoft.Alpha(opacity=100);
    filter: alpha(opacity=100);
    visibility: visible;
    -webkit-transition: all 0.2s ease-out;
    -moz-transition: all 0.2s ease-out;
    -o-transition: all 0.2s ease-out;
    transition: all 0.2s ease-out;
  }

  .locale-picker .menu .locale {
    height: 55px;
    line-height: 55px;
    padding: 0 20px;
    color: #555;
    background: #FFFFFF;
    border-bottom: 1px solid #EEE;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-transition: all 0.2s ease-out;
    -moz-transition: all 0.2s ease-out;
    -o-transition: all 0.2s ease-out;
    transition: all 0.2s ease-out;
  }

  .locale-picker .menu .locale:hover {
    background: #FAFAFA;
    -webkit-transition: all 0.2s ease-out;
    -moz-transition: all 0.2s ease-out;
    -o-transition: all 0.2s ease-out;
    transition: all 0.2s ease-out;
  }

  .locale-picker .menu .locale img {
    margin: 0 10px 0 0;
    position: relative;
    top: 2px;
  }

  .locale-picker.top .menu {
    top: auto;
    bottom: 60px;
    left: 20px;
  }

  .locale-picker .locale {
    text-align: left;
  }

  .locale-picker .locale img {
    max-width: 22px;
  }

  .locale-picker .locale.selected {
    height: 44px;
    padding: 10px 20px;
    -webkit-border-radius: 100px;
    -moz-border-radius: 100px;
    border-radius: 100px;
    -webkit-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
    -moz-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
    cursor: pointer;
  }

  .locale-picker .locale.selected img {
    width: 30px;
    max-width: 100%;
    cursor: pointer;
  }

  .locale-picker .locale.selected .name {
    display: inline-block;
    margin: 0 0 0 12px;
    font-weight: 400;
    position: relative;
    top: -6px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// LanguagePicker.vue?e64aa902